import React, { useState } from 'react';
import TopupCard from '../../components/TopupCard';

export default function WalletTopCard({ wallet }) {
  const [openFund, setOpenFund] = useState(false);

  return (
    <div className={'p-5 shadow bg-white w-full'}>
      <div className={'flex flex-row justify-between items-center'}>
        <div>
          <h3 className={'text-yellow-500 font-light text-xl'}>
            Wallet Top-up
          </h3>
        </div>

        <div>
          <button
            onClick={() => setOpenFund(!openFund)}
            className={
              'shadow bg-yellow-500 text-white rounded-sm px-2 lg:px-3 py-1 lg:py-2 text-sm'
            }
          >
            Add Funds
          </button>
        </div>
      </div>

      {openFund ? <TopupCard wallet={wallet} /> : null}
    </div>
  );
}
